import APICaller from '../library/APICaller'
import FormGenerator from './FormGenerator'

const ProductServices = {
  /**
   * selectProductList
   * @return {Promise}
   */
  getProducts ({ searchText, category }) {
    return APICaller.get('/api/v1/products', { searchText, category })
  },

  getUsedAmountProductList ({ companyCode, search, pageNo, size, orderCol, desc, category, startMonth, endMonth}) {
    return APICaller.get('/api/v1/products/used-amount-product-list',{ companyCode, search, pageNo, size, orderCol, desc, category, startMonth, endMonth})
  },
  getProductRankList ({ companyCode, search, pageNo, size, orderCol, desc, category, startMonth, endMonth}) {
    return APICaller.get('/api/v1/products/product-used-amount-rank',{ companyCode, search, pageNo, size, orderCol, desc, category, startMonth, endMonth})
  },
  /**
   * updateProduct
   * @param  {String} params.brochureFileId brochure fileId
   * @param  {String} params.companyCode 회사코드
   * @param  {String} params.etcFileId etc fileId
   * @param  {String} params.introFileId intro fileId
   * @param  {String} params.isNew 신규
   * @param  {String} params.remark 상품 설명
   * @param  {String} params.stat 활성화 상태
   * @param  {String} params.stratCode code
   * @param  {String} params.userId 사용자 아이디
   * @return {Promise}
   */
  putProducts ({ brochureFileId, companyCode, etcFileId, introFileId, isNew, remark, stat, stratCode, userId } ) {
    return APICaller.put('/api/v1/products', { brochureFileId, companyCode, etcFileId, introFileId, isNew, remark, stat, stratCode, userId } )
  },
  /**
   * selectProduct
   * @param  {String} startCode code
   * @return {Promise}
   */
  getProductsWithStartCode(startCode) {
    return APICaller.get(`/api/v1/products/${startCode}`)
  },
  /**
   * 상품 파일 삭제
   * @param  {String} params.fileId 파일 아이디
   * @param  {String} params.stratCode stratCode
   * @param  {String} params.type 파일 타입
   * @return {Promise}
   */
  putProductsFiles({fileId, stratCode, type}) {
    return APICaller.put(`/api/v1/products/files?fileId=${fileId}&stratCode=${stratCode}&type=${type}`)
  },
  getProductsProductManager() {
    return APICaller.get(`/api/v1/products/product-manager`)
  }
}

export default ProductServices



// WEBPACK FOOTER //
// ./src/services/ProductServices.js